import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { ExternalFileManagerPanelComponent } from './lib/external-file-manager-panel.component'

export * from './lib/external-file-manager.module'
export * from './panel-key'
export const ExternalFileManagerKey = 'external-file-manager-qas1y' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
export * from './lib/services/bulkActivateNewerExternalData/bulkActivateExternalData.service'
export { BulkActivateNewerExternalDataComponent } from './lib/components/bulk-activate-newer-external-data/bulk-activate-newer-external-data.component'

export const ExternalFileManagerPanelConfig: PanelConfig = {
  key: ExternalFileManagerKey,
  title: 'External File Manager',
  description:
    'Activate and inactivate external data files. View Prometheus position and transaction data.',
  category: PanelCategory.DELIVERY,
  panelComponent: ExternalFileManagerPanelComponent,
  accessPermission: 'accessExternalFileManagerPanel',
}
